import React from "react";
import { observer } from "mobx-react";
import { useTranslation } from "react-i18next";

import { useStore } from "../store";

type TLocoKey =
  | "project_info_downloads"
  | "feed_recent_title"
  | "feed_search_guide"
  | "feed_download_button"
  | "feed_downloaded_button"
  | "feed_more"
  | "feed_cancel_button"
  | "feed_download_storage_error_msg"
  | "feed_download_network_error_msg"
  | "feed_download_unknown_error_msg"
  | "feed_server_connection_failed_error_msg"
  | "feed_download_stopped_error_msg"
  | "feed_server_unknown_error_msg"
  | "feed_share_require_update_msg"
  | "feed_version_update_msg"
  | "download_failed"
  | "installing_assets"
  | "feed_completed"
  | "feed_download_completed"
  | "feed_downloading_guide_msg"
  | "button_ok"
  | "feed_search_no_result"
  | "button_later"
  | "button_update_now"
  | "feed_category_all";

interface Props {
  locoKey: TLocoKey;
  languageCode?: string;
}

/**
 * convert loco key
 * @param key loco key
 * @param languageCode language
 * @returns string
 */
const translationKey = ({ locoKey, languageCode }: Props) =>
  `${languageCode}.pfw.${locoKey}`;

/**
 * translation i18n
 * @param key loco key
 * @returns JSX
 */
export const TranslationJSX = observer(({ locoKey }: Props) => {
  const { t } = useTranslation();
  const {
    appStore: {
      appState: { languageCode },
      onInitLanguage,
    },
  } = useStore();

  const tKey = translationKey({ languageCode, locoKey });

  // loco에 등록된 language code가 아닌 경우 en 으로 반환
  let label = t(tKey);
  if (label === tKey) {
    onInitLanguage();
    const enKey = translationKey({ languageCode: "en", locoKey });
    label = t(enKey);
  }
  return <React.Fragment>{label}</React.Fragment>;
});

/**
 * translation i18n
 * @param key loco key
 * @param language language
 * @returns string
 */
export const TranslationStr = ({ locoKey, languageCode }: Props) => {
  const { t } = useTranslation();

  const tKey = translationKey({ languageCode, locoKey });

  // loco에 등록된 language code가 아닌 경우 en 으로 반환
  let label = t(tKey);
  if (label === tKey) {
    const enKey = translationKey({ languageCode: "en", locoKey });
    label = t(enKey);
  }
  return label;
};

/**
 * languageCode ar property
 * @param languageCode
 */
export const languageAr = (languageCode: string) => {
  const isAr = languageCode.includes("ar");
  const className = isAr ? "reverse" : "";

  if (isAr) {
    return { isAr, className, dir: "rtl" };
  }
  return { isAr, className, dir: "ltr" };
};
